import { render, staticRenderFns } from "./SlaughterScheduleCard.vue?vue&type=template&id=bb831b00&scoped=true&"
import script from "./SlaughterScheduleCard.vue?vue&type=script&lang=js&"
export * from "./SlaughterScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./SlaughterScheduleCard.vue?vue&type=style&index=0&id=bb831b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb831b00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VContainer,VIcon,VRow,VSheet,VSpacer})
